import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { theme } from 'antd';
import { RootState } from 'store/configureStore';
import { TitleListEN, TitleListsCompliance } from 'store/ducks/globalTypes';
import { TitleKeyCompliance } from 'store/ducks/Management/types';
import TitleBar from 'components/TitleBar';
import GoBackButton from 'components/GoBackButton';
import dataManagementWorkflow from 'constants/dataManagementWorkflow';
import CardComponent from 'components/CardComponent';
import i18n from 'constants/translation/i18n';
import { useTranslation } from 'react-i18next';
import * as Styled from 'components/Layouts/Layout.styled';

const { useToken } = theme;

const DataManagementWorkflow: React.FC = () => {
  const { token } = useToken();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = useSelector((state: RootState) => state.global.lang);
  const [dataManagementWorkflowArray, setDataManagementWorkflowArray] =
    useState(dataManagementWorkflow());
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedArea = decodeURIComponent(query.get('selected') || '');
  const { scheme } = useSelector((state: RootState) => state.global);

  useEffect(() => {
    i18n.changeLanguage(lang);
    setDataManagementWorkflowArray(dataManagementWorkflow());
  }, [lang]);

  const getTitleKeyFromTitle = (
    selectedTitle: string,
    titleEnum: Record<TitleKeyCompliance, string>
  ): TitleKeyCompliance => {
    return (
      (Object.keys(titleEnum) as TitleKeyCompliance[]).find(
        (key) => titleEnum[key] === selectedTitle
      ) ?? 'COMP_EST'
    );
  };

  const TitleKeyComplianceLayout = getTitleKeyFromTitle(
    selectedArea,
    TitleListsCompliance['en']
  );

  const handleCardClick = (item: {
    area: string;
    title: string;
    href: string;
  }) => {
    if (item.href) {
      navigate(item.href);
    }
  };

  return (
    <Styled.StyledLayout token={token}>
      <TitleBar
        title={i18n.t('DATA_MANAGEMENT')}
        goBackButtons={
          <>
            <GoBackButton
              to='/workingAreaDetails/rules-to-evidence'
              text={t('GO_BACK')}
            />
            <GoBackButton to='/working_area' text={t('GO_TO_WORKING_AREAS')} />
          </>
        }
      />
      <Styled.HorizontalLayout theme={scheme}>
        <Styled.Container>
          <Styled.GridContainer token={token}>
            {dataManagementWorkflowArray.map((item) => (
              <Styled.RelativeContainer
                key={item.area}
                onClick={() => handleCardClick(item)}
              >
                <CardComponent
                  area={item.title}
                  infoText={''}
                  href={item.href}
                  textOnTop=''
                />
              </Styled.RelativeContainer>
            ))}
          </Styled.GridContainer>
        </Styled.Container>
      </Styled.HorizontalLayout>
    </Styled.StyledLayout>
  );
};

export default DataManagementWorkflow;
